import { ConfigurableToolbar } from './ConfigurableDataGridToolbar';
import { EnhancedToolbar } from './EnhancedToolbar';

interface DataGridToolbarProps {
  service: any;
  outerParams?: any;
  useGenericToolbar: boolean;
  genericToolbarConfig?: any;
  disableExport?: boolean;
  showGridControls?: boolean;
  disableEdit?: boolean;
}

/**
 * A stable, standalone Toolbar component for the DataGrid.
 * Declared outside the main component body to completely eliminate remount loops.
 */
export const DataGridToolbar = ({
  service,
  outerParams,
  useGenericToolbar,
  genericToolbarConfig,
  disableExport,
  showGridControls,
  disableEdit
}: DataGridToolbarProps) => {
  const activeWarehouseId = outerParams?.warehouse_id ? Number(outerParams.warehouse_id) : null;

  if (useGenericToolbar) {
    return (
      <ConfigurableToolbar
        service={service}
        outerParams={outerParams}
        disableExport={disableExport}
        entityId={+outerParams.warehouse_id}
        showGridControls={showGridControls}
        filters={genericToolbarConfig?.filters || []}
        actions={genericToolbarConfig?.actions || []}
        sx={genericToolbarConfig?.sx}
      />
    );
  }

  return (
    <EnhancedToolbar
      service={service}
      entityId={activeWarehouseId}
      outerParams={outerParams}
      disableEdit={disableEdit}
      disableExport={disableExport}
    />
  );
};
